// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--32-9P";
export var activated = "styles-module--activated--1bH7W";
export var handmade_logo = "styles-module--handmade_logo--341m5";
export var wrapper = "styles-module--wrapper--1F_kK";